import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_CREATE_COACH_FIELDS from 'coaching/queries/GetCreateCoachFields.gql';
import { GetCreateCoachFields } from 'coaching/queries/__generated__/GetCreateCoachFields';

export type Props = {
  children: (props: {
    subjects?: string[];
    hourlyRatesInCents?: number[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCreateCoachFieldsContainer(props: Props) {
  return (
    <Query<GetCreateCoachFields> query={GET_CREATE_COACH_FIELDS}>
      {({ loading, error, data }) => {
        return props.children({
          subjects: data?.coaching?.getCoachableSubjects?.subjects,
          hourlyRatesInCents: data?.coaching?.getCoachingHourlyRates?.hourlyRatesInCents,
          loading,
          error,
        });
      }}
    </Query>
  );
}
